import { defaultStateDataCurrent } from 'app/common/ui-components/filter'

const expandSubsidiesItems = () => [
  [
    {
      id: 'expandSubsidies',
      title: 'Не группировать категории льгот по индивидуальным справкам',
    },
  ],
  defaultStateDataCurrent,
]

export default expandSubsidiesItems
